import { PriceCustomizerFormValues } from './types';

export const PriceEvents = {
  SELECT_FREQUENCY: 'SELECT_FREQUENCY',
  SELECT_DAY_OF_WEEK: 'SELECT_DAY_OF_WEEK',
  SELECT_DAY_OF_MONTH: 'SELECT_DAY_OF_MONTH',
  SELECT_BIWEEKLY_START_DATE: 'SELECT_BIWEEKLY_START_DATE',
  SELECT_SEMI_MONTHLY_DATES: 'SELECT_SEMI_MONTHLY_DATES',
  JUMP_TO_STATE: 'JUMP_TO_STATE',
  RESET: 'RESET',
} as const;

export const DefaultCustomizerFormValues: PriceCustomizerFormValues = {
  frequency: 'weekly', // Agent default
  dayOfWeek: '',
  biweeklyDate: '',
  semiMonthlyDates: '',
  monthly: '',
};
